import { Card, Flex, Timeline } from 'antd';
import NoData from 'components/NoData';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useTaskHistoryQuery from 'screens/task-management/hooks/queries/useTaskHistoryQuery';
import { mapStatus } from 'screens/task-management/util';
import { renderDate } from 'utils/helpers';

const renderNote = (note?: string) => {
  if (!note) return;
  return (
    <Flex vertical className="task-management__notes-card" gap={4}>
      <span className="text-tertiary">Note:</span>
      <span>{note}</span>
    </Flex>
  );
};

type TaskHistoryContentProps = {
  taskId?: string;
  isLoading?: boolean;
};

const TaskHistoryContent = ({ taskId, isLoading }: TaskHistoryContentProps) => {
  const { t } = useTranslation();
  const { data, isLoading: isLoadingHistory } = useTaskHistoryQuery({ taskId });
  const timelineItems = useMemo(
    () =>
      data?.data?.map((data) => ({
        label: renderDate(data?.revisionDate),
        children: (
          <>
            <div>
              {data?.changesMessage &&
                t(`taskHistory.${data?.changesMessage}`, {
                  ...data?.relatedData,
                  oldValue: renderDate(data?.relatedData?.oldValue, 'N/A'),
                  newValue: renderDate(data?.relatedData?.newValue, 'N/A'),
                  status: mapStatus(
                    data?.relatedData?.status ?? 'N/A',
                  )?.toLowerCase(),
                  // to not format N/A as N&#x2F;A
                  interpolation: { escapeValue: false },
                })}
            </div>
            {renderNote(data?.relatedData?.note ?? '')}
          </>
        ),
      })),
    [data],
  );

  const isDataLoading = isLoading || isLoadingHistory;
  return (
    <>
      {isDataLoading && <Card loading={true} style={{ border: 'none' }} />}
      {!timelineItems?.length && !isDataLoading ? <NoData /> : null}
      <Timeline mode="left" items={timelineItems} />
    </>
  );
};

export default TaskHistoryContent;
